import React from 'react'
import Slider from 'react-slick'

const CaseStudyProductsSlider = (props) => {
    let settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: false,
        className: "productassociations"
    }

    return (
        <Slider {...settings}>
            {props.products.map((p) => (
                <div key={p.ProductName}>
                    {p.IsAvailableOnsite ?
                        <a href={p.ProductUrl}>
                            <img className="prodimage lazy" src={p.ThumbUrl} alt={p.ProductName} width="200" height="100" />
                        </a> : <img className="prodimage lazy" src={p.ThumbUrl} alt={p.ProductName} width="200" height="100" />}
                    <div className="prodname">{p.ProductName}</div>
                </div>
            ))}
        </Slider>
    )
}

export default CaseStudyProductsSlider